import { getDb } from '../LocalDB/LocalDB';

export const getLocalFlightDocumentContent = async (documentId: string): Promise<Blob | null> => {
    const document = await getDb().localDocumentContents.get(documentId);
    if (!document) {
        return null;
    }
    return document.content;
};

export const putLocalFlightDocumentContent = async (documentId: string, content: Blob): Promise<void> => {
    await getDb().localDocumentContents.put({ id: documentId, content });
};

export const deleteLocalFlightDocumentContent = async (documentId: string): Promise<void> => {
    await getDb().localDocumentContents.delete(documentId);
};

// An expense file is stored under its storage key, which exists before the upload does. The
// explicit false tells such a blob from a legacy document's, which never carries the mark.
export const putLocalExpenseContent = async (key: string, content: Blob): Promise<void> => {
    await getDb().localDocumentContents.put({ id: key, content, uploaded: false });
};

export const getLocalDocumentContentRow = async (id: string): Promise<LocalDocumentContent | undefined> =>
    getDb().localDocumentContents.get(id);

export const markLocalDocumentContentUploaded = async (id: string): Promise<void> => {
    await getDb().localDocumentContents.update(id, { uploaded: true });
};

// One file can sit in several expenses, so its blob goes only when no live expense holds its key.
export const deleteUnheldExpenseContents = async (keys: string[]): Promise<void> => {
    if (!keys.length) {
        return;
    }
    const db = getDb();
    const records = await db.flightExpenses.toArray();
    const heldKeys = new Set(
        records.filter((record) => !record.deleted).flatMap((record) => record.contentKeys.map((entry) => entry.key))
    );
    await db.localDocumentContents.bulkDelete(keys.filter((key) => !heldKeys.has(key)));
};

export type LocalDocumentContent = {
    id: string;
    content: Blob;
    uploaded?: boolean;
};
